// import React from 'react';
// import {
//   Card, CardContent, Typography, Grid, Table, TableHead, TableRow,
//   TableCell, TableBody, Paper, Box
// } from '@mui/material';

// const subjects = [
//   {
//     subject: 'React Native',
//     faculty: 'Prof. Sneha Rai',
//     total: 60,
//     present: 52,
//     absent: 8,
//   },
//   {
//     subject: 'DBMS',
//     faculty: 'Prof. Arjun Patel',
//     total: 60,
//     present: 55,
//     absent: 5,
//   },
//    {
//     subject: 'React Native',
//     faculty: 'Prof. Sneha Rai',
//     total: 60,
//     present: 52,
//     absent: 8,
//   },
//   {
//     subject: 'DBMS',
//     faculty: 'Prof. Arjun Patel',
//     total: 60,
//     present: 55,
//     absent: 5,
//   },
// ];

// const absentees = [
//   { name: 'Aaliya Tanweer', subject: 'React Native', section: 'BCA A' },
//   { name: 'Mohammed Najih', subject: 'DBMS', section: 'BCA A' },
//   { name: 'Neva Zenin', subject: 'React Native', section: 'BCA B' },
// ];

// const HodDashboard = () => {
//   return (
//     <Box p={3}>
//       <Typography variant="h4" mb={3}>HOD Dashboard</Typography>

//       {/* Cards Section */}
//       <Grid container spacing={3}>
//         {subjects.map((item, index) => (
//           <Grid item xs={12} md={6} key={index}>
//             <Card sx={{ boxShadow: 3 }}>
//               <CardContent>
//                 <Typography variant="h6">{item.subject}</Typography>
//                 <Typography color="text.secondary">Faculty: {item.faculty}</Typography>
//                 <Typography>Total: {item.total}</Typography>
//                 <Typography color="green">Present: {item.present}</Typography>
//                 <Typography color="red">Absent: {item.absent}</Typography>
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Absentees Table */}
//       <Typography variant="h5" mt={5} mb={2}>Absentees List</Typography>
//       <Paper>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Student Name</TableCell>
//               <TableCell>Subject</TableCell>
//               <TableCell>Section</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {absentees.map((absent, index) => (
//               <TableRow key={index}>
//                 <TableCell>{absent.name}</TableCell>
//                 <TableCell>{absent.subject}</TableCell>
//                 <TableCell>{absent.section}</TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </Paper>
//     </Box>
//   );
// };

// export default HodDashboard;

import React from 'react';
import {
  Card, CardContent, Typography, Table, TableHead, TableRow,
  TableCell, TableBody, Paper, Box,Grid
} from '@mui/material';
import { DataGrid } from "@mui/x-data-grid";
// Mock subject stats
const subjects = [
  { subject: 'React Native', faculty: 'Prof. Sneha Rai', total: 60, present: 52, absent: 8 },
  { subject: 'DBMS', faculty: 'Prof. Arjun Patel', total: 60, present: 55, absent: 5 },
  { subject: 'Maths', faculty: 'Prof. Ravi', total: 60, present: 49, absent: 11 },
  { subject: 'OS', faculty: 'Prof. Nisha', total: 60, present: 50, absent: 10 },
  { subject: 'CN', faculty: 'Prof. Rahul', total: 60, present: 58, absent: 2 },
  { subject: 'English', faculty: 'Prof. Meera', total: 60, present: 56, absent: 4 },
  { subject: 'C++', faculty: 'Prof. Ramesh', total: 60, present: 53, absent: 7 },
  { subject: 'Python', faculty: 'Prof. Leela', total: 60, present: 51, absent: 9 },
];

// Today's & yesterday's absentees
const absentees = [
  { name: 'Aaliya Tanweer', subject: 'React Native', section: 'BCA A', date: '2025-06-06' },
  { name: 'Mohammed Najih', subject: 'DBMS', section: 'BCA A', date: '2025-06-06' },
  { name: 'Neva Zenin', subject: 'React Native', section: 'BCA B', date: '2025-06-07' },
];
const absenteeColumns = [
  { field: 'name', headerName: 'Student Name', flex: 1 },
  { field: 'subject', headerName: 'Subject', flex: 1 },
  { field: 'section', headerName: 'Section', flex: 1 },
  { field: 'date', headerName: 'Date', flex: 1 },
];

const absenteeRows = absentees.map((item, index) => ({
  id: index + 1,
  name: item.name,
  subject: item.subject,
  section: item.section,
  date: item.date,
}));

// Low attendance students
const lowAttendance = [
  { name: 'Krishna M.', subject: 'DBMS', attendance: '65%' },
  { name: 'Jaya R.', subject: 'OS', attendance: '60%' },
  { name: 'Anil P.', subject: 'Python', attendance: '58%' },
];
const lowAttendanceColumns = [
  { field: 'name', headerName: 'Student Name', flex: 1 },
  { field: 'subject', headerName: 'Subject', flex: 1 },
  { field: 'attendance', headerName: 'Attendance %', flex: 1 },
];

const lowAttendanceRows = lowAttendance.map((item, index) => ({
  id: index + 1,
  name: item.name,
  subject: item.subject,
  attendance: item.attendance,
}));


const HodDashboard = () => {
  return (
    <Box p={3}style={{ height:'100%' , width: '98%',marginLeft:'5px' ,overflow: "scroll",marginRight:'10px' }}>
      <Typography variant="h4" mb={3}>HOD Dashboard</Typography>

      {/* Cards Section */}
      <Box
        sx={{
          display: 'flex',
          overflowX: 'auto',
          gap: 2,
          mb: 4,
          pb: 1,
        }}
      >
  <Grid container spacing={3}>
  {subjects.map((item, index) => (
    <Grid item xs={12} sm={6} md={3} key={index}>
      <Card sx={{ boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h6">{item.subject}</Typography>
          <Typography color="text.secondary">Faculty: {item.faculty}</Typography>
          <Typography>Total: {item.total}</Typography>
          <Typography sx={{ color: 'green' }}>Present: {item.present}</Typography>
          <Typography sx={{ color: 'red' }}>Absent: {item.absent}</Typography>
        </CardContent>
      </Card>
    </Grid>
  ))}
</Grid>

      </Box>
{/* <Typography variant="h5" mt={5} mb={2}>Attendance Reports</Typography> */}

{/* <Grid container spacing={3}> */}
  {/* Absentees Table */}
  {/* <Grid item xs={12} md={6}>
    <Typography variant="h6" mb={2}>Absentees List (Today & Yesterday)</Typography>
    <Paper sx={{ p: 2 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Student Name</TableCell>
            <TableCell>Subject</TableCell>
            <TableCell>Section</TableCell>
            <TableCell>Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {absentees.map((absent, index) => (
            <TableRow key={index}>
              <TableCell>{absent.name}</TableCell>
              <TableCell>{absent.subject}</TableCell>
              <TableCell>{absent.section}</TableCell>
              <TableCell>{absent.date}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  </Grid> */}

  {/* Low Attendance Table */}
  {/* <Grid item xs={12} md={6}>
    <Typography variant="h6" mb={2}>Students With Low Attendance</Typography>
    <Paper sx={{ p: 2 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Student Name</TableCell>
            <TableCell>Subject</TableCell>
            <TableCell>Attendance %</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lowAttendance.map((student, index) => (
            <TableRow key={index}>
              <TableCell>{student.name}</TableCell>
              <TableCell>{student.subject}</TableCell>
              <TableCell>{student.attendance}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  </Grid> */}
{/* </Grid> */}
<Grid container spacing={3} mt={3}>
  {/* Absentees Table */}
  <Grid item xs={12} md={6}>
    <Typography variant="h6" mb={1}>Absentees List (Today & Yesterday)</Typography>
    <DataGrid
      rows={absenteeRows}
      columns={absenteeColumns}
      pageSize={5}
      rowsPerPageOptions={[5]}
      autoHeight
      disableSelectionOnClick
      sx={{
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: '#f5f5f5',
          fontWeight: 'bold',
        }
      }}
    />
  </Grid>

  {/* Low Attendance Table */}
  <Grid item xs={12} md={6}>
    <Typography variant="h6" mb={1}>Students With Low Attendance</Typography>
    <DataGrid
      rows={lowAttendanceRows}
      columns={lowAttendanceColumns}
      pageSize={5}
      rowsPerPageOptions={[5]}
      autoHeight
      disableSelectionOnClick
      sx={{
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: '#f5f5f5',
          fontWeight: 'bold',
        }
      }}
    />
  </Grid>
</Grid>

    </Box>
  );
};

export default HodDashboard;
